import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const CalendarViewWeekIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"calendar_view_week"} ref={ref}/>
});

CalendarViewWeekIcon.displayName = "CalendarViewWeekIcon";
